import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1b741669&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=1b741669&prod&lang=less"
import style1 from "./list.vue?vue&type=style&index=1&id=1b741669&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b741669",
  null
  
)

export default component.exports